import { authRoles } from 'app/auth';
import KerdesTable from 'app/admin/kerdes/table/KerdesTable';

const kerdesRouteConfig = [
  {
    path: '/kerdes/:sessionNameParam?',
    exact: true,
    component: KerdesTable,
    auth: [...authRoles.admin, ...authRoles.reviewer]
  }
];

export default kerdesRouteConfig;
